<div class="cpcontent googlesignin" [hidden]="isAuthenticatedWithFirebase">
    <h5>Signin with Google to access the Firebase database</h5>
    <br>
    <div class="row">
        <div class="col-md-6">
            <button class="btn btn-primary" (click)="signInWithGoogle()">Sign in with Google</button>
        </div>
    </div>
</div>
<div class="cpcontent" [hidden]="!isAuthenticatedWithFirebase">
    <h1 style="display:inline-block">Lesson Plans</h1>
    <!-- list all lessonplans in options of select-->
    <div class="row">
        <div class="col-md-3">
            <h5>Select Lesson Plan</h5>
            <select class="form-control" [(ngModel)]="selectedLessonPlan" (change)="onSelect(selectedLessonPlan)">
                <option *ngFor="let lessonplan of lessonplansArray" [ngValue]="lessonplan.key">{{lessonplan.property}}</option>
            </select>
        </div>
        <div class="col-md-6">
            <h5>New Lesson Plan</h5>
            <sa-input-text [(text)]="lessonplanname" [title]="'Name'" style="display:inline-block"></sa-input-text>
            <div style="display:inline-block;vertical-align: top;">
                <button class="btn btn-primary" (click)="AddLessonPlan()" style="margin-left:10px">Add New Lesson Plan</button><br>
                <button class="btn btn-primary" (click)="CopyLessonPlan()"  style="margin-left:10px;margin-top:10px">Copy Lesson Plan From Selected Lesson Plan</button>
            </div>
        </div>
        <div class="col-md-3">
            <button class="btn btn-danger" (click)="DeleteLessonPlan()">Delete Selected Lesson Plan</button>
        </div>
    </div>
    <br><br>
    Selected Lessonplan : <b>{{selectedLessonPlanName}}</b>
    <button class="btn btn-primary" (click)="openModal(null)" style="margin-left:20px;">Add Step</button>
    <br><br>
    <table class="table table-bordered table-striped">
        <tr>
            <th>Sequence</th>
            <th>Name</th>
            <th>Description</th>
            <th>Assets</th>
            <th>Delete</th>
        </tr>
        <tr *ngFor="let lessonplanstep of lessonplansteps">
            <td class="link" (click)="openModal(lessonplanstep)">{{lessonplanstep.seqno}}</td>
            <td>{{lessonplanstep.name}}</td>
            <td>{{lessonplanstep.description}}</td>
            <td>{{lessonplanstep.assets}}</td>
            <td><button class="btn btn-danger" (click)="deleteLessonplanStep(lessonplanstep)">Delete</button></td>
        </tr>
    </table>
    <!-- {{lessonplansteps | json}} -->
</div>
<!-- Modal Lessonplanstep---------------------------------------------------------------------------->
<div *ngIf="showModalLessonplanStep" #testmodal class="cpmodal">
    <div class="cpmodal-content" style="max-width:800px;margin-top:5%">
        <h5>Interactivity</h5>
        <sa-input-text [(text)]="lessonplanStep.name" [title]="'Name'"></sa-input-text>
        <sa-input-text [(text)]="lessonplanStep.description" [title]="'Description'"></sa-input-text>
        <sa-input-text [(text)]="lessonplanStep.assets" [title]="'Asset'"></sa-input-text>
        <sa-input-number [(text)]="lessonplanStep.seqno" [title]="'SeqNo' "></sa-input-number>
        <br>
        <button class="btn btn-primary" (click)="updateLessonplanStep()">Update</button>

        <button class="btn btn-primary" style="float:right" (click)="showModalLessonplanStep = false">Close Modal</button>
    </div>
</div>